export const MenuProfile = 
[
    {
        name: 'Maklumat Pelayanan',
        link: '/static/maklumat-pelayanan',
    },
    {
        name: 'Visi dan Misi',
        link: '/static/visi-dan-misi',
    },
    {
        name: 'Struktur Organisasi',
        link: '/static/struktur-organisasi',
    },
    {
        name: 'Bagan Organisasi',
        link: '/static/bagan-organisasi',
    },
    {
        name: 'Rekognisi',
        link: '/static/rekognisi',
    },
    // {
    //     name: 'SK Penetapan Website',
    //     link: '/static/sk-penetapan-website',
    // },
    // {
    //     name: 'SK Tim pengelola Website',
    //     link: '/static/sk-tim-pengelola-website',
    // },
    // {
    //     name: 'SK Penunjukan Petugas Meja Pelayanan',
    //     link: '/static/sk-penunjukan-petugas-meja-pelayanan-pengelola-website',
    // },
]

export const MenuInformasiLainnya = 
[
    {
        name: 'Daftar Berita',
        link: '/berita',
    },
    {
        name: 'Daftar Artikel',
        link: '/artikel',
    },
    {
        name: 'Galeri Foto',
        link: '/galeri-foto',
    },
    {
        name: 'Galeri Video',
        link: '/galeri-video',
    },
]

export const MenuInformasi = 
[
    {
        name: 'Layanan Online',
        link: '/informasi/layanan',
        image: '/img/layanan.png',
        description: 'Kami memberikan pelayanan terbaik pada anda dan tanpa biaya apapun'
    },
    {
        name: 'Pengumuman',
        link: '/informasi/pengumuman',
        image: '/img/pengumuman.png',
        description: 'Cari tau pengumuman resmi dan valid dari kami disini'
    },
    {
        name: 'Agenda',
        link: '/informasi/agenda',
        image: '/img/agenda.png',
        description: 'Ketahui agenda maupun kegiatan kami yang akan datang'
    },
    {
        name: 'Bank Data',
        link: '/informasi/bank-data',
        image: '/img/bank-data.png',
        description: 'Semua informasi kebutuhan terkait dinas pendidikan dapat ditemukan disini'
    },
]

export const MenuAduan = 
[
    {
        name: 'SK Pengelolaan Pengaduan Pelayanan Publik',
        link: '/aduan/sk-pengelolaan-pengaduan-pelayanan-publik',
    },
    {
        name: 'Pengelola Aduan Dinas',
        link: '/aduan/pengelola-aduan-dinas',
    },
    {
        name: 'Pengelola Aduan Ulas',
        link: '/aduan/pengelola-aduan-ulas',
    },
    {
        name: 'Unit Layanan Aduan',
        link: '/unit-layanan-aduan',
    },
]